import { Node } from "@tiptap/core"
import { mergeAttributes, VueNodeViewRenderer } from "@tiptap/vue-3"

export default (config, View) => {
  return Node.create({
    addAttributes() {
      return {
        id: {
          default: null,
        },
        ...this.options.schema.addAttributes
      }
    },

    parseHTML() {
      return this.options.schema.parseHTML
    },

    renderHTML({ HTMLAttributes }) {
      return [this.options.schema.tag, mergeAttributes(HTMLAttributes)]
    },

    addNodeView() {
      return VueNodeViewRenderer(View)
    },

    ...config,
  })
}
